/** Semantic IDs used by compose functions in device-abc-info.ts.
 * The consumer provides a mapping from these IDs to i18n keys. */
export const COMPOSE_LABEL_IDS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  UNKNOWN: 'UNKNOWN',
  PARALLEL_MODE: 'PARALLEL_MODE',
  INDEPENDENT_MODE: 'INDEPENDENT_MODE',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
} as const;

export type ComposeLabelId = typeof COMPOSE_LABEL_IDS[keyof typeof COMPOSE_LABEL_IDS];
